import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import "flatpickr/dist/themes/material_blue.css"
import SettingSidebar from "../../../components/VerticalLayout/SettingSidebar";
import { getUserDetail, updateUserCurrency } from "../../../store/actions"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import GeneralSettingMenu from "../menu/general-setting-menu";
import UpdateButton from "components/buttons/updateBtn";
import CurrencyDropdown from "components/dropdowns/Other/CurrencyDropdowns";
import EmailSettingMenu from "../menu/email-setting-menu";
import ActionEdit from "components/buttons/actionEdit";
import SaveButton from "components/buttons/save";
import JoditEditor from 'jodit-react';
import { API_URL } from "helpers/app_url";
import axios from "axios";
import { template } from "lodash";
import RichTextEditor from "components/dropdowns/ContentEditor";
import RsAdNewV2 from "components/buttons/Adnew-v2";
import EmailContentEditor from "components/dropdowns/emailContentEditor";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";
class CustomeTemplates extends Component {
  constructor(props) {
    super(props)
    this.state = {
      templates: [],
      tags: [],
      loadings: true,
    }
    this.toggleUpdate = this.toggleUpdate.bind(this);
    this.toggleAddNew = this.toggleAddNew.bind(this);
  
  }
  componentDidMount() {
    const { onGetUserDetail } = this.props;
    onGetUserDetail(localStorage.getItem('userId'));
    this.fetchAllTemplates();
  
  }
addToggle() {
    this.setState(prevState => ({
      isAddNew: !prevState.isAddNew
    }));
    }
 toggleAddNew() {
    this.setState({ isAddNew: !this.state.isAddNew });
    //this.addToggle();
  }
  updateToggle() {
    this.setState(prevState => ({
      isUpdate: !prevState.isUpdate
    }));
    }
  toggleUpdate() {
    this.setState({ template: "", isEdit: false, isUpdate: !this.state.isUpdate });
    this.updateToggle();
  }
  toggleUpdate = arg => {
    const template = arg;
    this.setState({
      template: {
        id: template.id,
        templateId: template.templateId,
        templateTitle: template.templateTitle,
        templateCategoryId: template.templateCategoryId,
        templateEmailSubject: template.templateEmailSubject,
        templateEmailBody: template.templateEmailBody,
        agentId: localStorage.getItem('userId'),
        isActive: template.isActive,
      },
      isEdit: true,
    });
    this.updateToggle();
  }



  fetchAllTemplates() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      AgentId: localStorage.getItem('userId'),

    };
    axios
      .get(`${API_URL}AgentCustomEmailTemplate/allAgent`, { headers, params })
      .then((response) => {
        this.setState({ templates: response.data, loadings: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loadings: false });
      });
  }
  handleSubmit = (values) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const data = {
     
      templateTitle: values.templateEmailSubject,
      templateCategoryId:0,
      templateEmailSubject: values.templateEmailSubject,
      templateEmailBody: values.templateEmailBody,
      agentId: parseInt(localStorage.getItem('userId')),
      isActive: values.isActive,
    };
    toast.loading("Please wait ...");
    axios
      .post(`${API_URL}AgentCustomEmailTemplate`, data, { headers })
      .then((response) => {
        if (response.data.success) {
          toast.dismiss();
          toast.success("Saved successfully");
            this.fetchAllTemplates();
            this.addToggle();

        } else {
          toast.dismiss();
          toast.error(response.data.validationErrors?.[0] || "An error occurred.");
        }
      })
      .catch((error) => {
        this.setState({ loadings: false });

      }
      );
  }


   handleUpdate = (values) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const data = {
        id: values.id,
        templateId: values.templateId,
        templateTitle: values.templateEmailSubject,
        templateCategoryId:0,
        templateEmailSubject: values.templateEmailSubject,
        templateEmailBody: values.templateEmailBody,
        agentId: parseInt(localStorage.getItem('userId')),
        isActive: values.isActive,
    };
    toast.loading("Please wait ...");
    axios
      .put(`${API_URL}AgentCustomEmailTemplate`, data, { headers })
      .then((response) => {
        if (response.data.success) {
          toast.dismiss();
          toast.success("Updated successfully");
            this.fetchAllTemplates();
            this.updateToggle();

        } else {
          toast.dismiss();
          toast.error(response.data.validationErrors?.[0] || "An error occurred.");
        }
      })
      .catch((error) => {
        this.setState({ loadings: false });

      }
      );
  }



  render() {
    const { templates, template } = this.state;
    return (
      <React.Fragment>
        {this.state.loadings && this.state.loadings ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <ToastContainer autoClose={2000} />
        <div className="page-content">
          <MetaTags>
            <title>Email Templates | Realty Space</title>
          </MetaTags>
          <Container fluid>
            <Row className="mb20">
              <Col xl="6">
                <Breadcrumbs
                  title={this.props.t("Agent")}
                  breadcrumbItem={this.props.t("General Settings")}
                />
              </Col>
              <Col xl="6" className="text-end">
               <div className="pt-2 mt-2 d-flex justify-content-center justify-content-xl-end flex-wrap">
                                     
                                     <RsAdNewV2 to="#" onClick={this.toggleAddNew} className="text-purple" iconClass="bx bx-plus-medical">Add new</RsAdNewV2>{" "}
                                     
                                   </div>    
              </Col>
            </Row>
            <Row>
              <Col xl="3">
                <SettingSidebar />
              </Col>
              <Col xl="9">
                        
                <Card>
                  <CardBody>
                      
                    <table className="table table-bordered">
                      <thead className="table-light striped">
                        <tr>
                          <th>Template Name</th>
                        
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {templates.map((template, index) => (
                          <tr key={index}>
                            <td>{template.templateTitle}
                             

                            </td>
                           
                            <td>
                              <div className="d-flex">
                                <ActionEdit onClick={() => this.toggleUpdate(template)} />

                                <ActionDelete onClick={()=>this.handelDelete(template)}    />

                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>



        <Offcanvas
          isOpen={this.state.isUpdate}
          direction="end"
          toggle={this.toggleUpdate}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.toggleUpdate}>
            Update  Template
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                id: template?.id,
                templateId: template?.templateId,
                templateTitle: template?.templateTitle,
               
                templateCategoryId: template?.templateCategoryId,
            
                templateEmailSubject: template?.templateEmailSubject,
                templateEmailBody: template?.templateEmailBody,
             
                agentId: localStorage.getItem('userId'),
               
                isActive: template?.isActive,
              }}
              validationSchema={Yup.object().shape({
                templateEmailSubject: Yup.string().required("This is required"),
                //templateFilterTags: Yup.string().required("This is required")
              })}

              onSubmit={this.handleUpdate}

            >
              {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >


                  <Row>

                    <Col md="12">
                     

                     

                      <FormGroup className="mb-3">
                        <Label htmlFor="templateEmailSubject">Email subject*</Label>
                        <SafeField
                          name="templateEmailSubject"
                          className={
                            "form-control" +
                            (errors.templateEmailSubject && touched.templateEmailSubject
                              ? " is-invalid"
                              : "")
                          }
                          onChange={handleChange}
                          type="text"
                        />
                        <ErrorMessage
                          name="templateEmailSubject"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                      <FormGroup>

                        <Label htmlFor="templateEmailBody">Email body</Label>
                          <EmailContentEditor
                          name="templateEmailBody"
                          setFieldValue={setFieldValue}
                          initialContent={values.templateEmailBody}
                          placeholder="Enter email content here..."
                        />
                       
                      </FormGroup>

                   
                    </Col>

                  </Row>






                  <div><SaveButton>Save</SaveButton></div>

                </Form>
              )}
            </Formik>

          </OffcanvasBody>
        </Offcanvas>

          <Offcanvas
          isOpen={this.state.isAddNew}
          direction="end"
          toggle={this.toggleAddNew}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.toggleAddNew}>
            New Template
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
               
               
                templateTitle: '',
                templateEmailSubject: '',
                templateEmailBody: '',
                agentId: localStorage.getItem('userId'),
                isActive: true,
              }}
              validationSchema={Yup.object().shape({
                //templateTitle: Yup.string().required("This is required"),
                templateEmailSubject: Yup.string().required("This is required")
              })}

              onSubmit={this.handleSubmit}

            >
              {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >


                  <Row>

                    <Col md="12">
                    

                    

                      <FormGroup className="mb-3">
                        <Label htmlFor="templateEmailSubject">Email subject*</Label>
                        <SafeField
                          name="templateEmailSubject"
                          className={
                            "form-control" +
                            (errors.templateEmailSubject && touched.templateEmailSubject
                              ? " is-invalid"
                              : "")
                          }
                          onChange={handleChange}
                          type="text"
                        />
                        <ErrorMessage
                          name="templateEmailSubject"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                      <FormGroup>

                        <Label htmlFor="templateEmailBody">Email body</Label>
                          <EmailContentEditor
                          name="templateEmailBody"
                          setFieldValue={setFieldValue}
                          initialContent={values.templateEmailBody}
                          placeholder="Enter email content here..."
                        />
                       
                      </FormGroup>

                   

                      
                    </Col>

                  </Row>






                  <div><SaveButton>Save</SaveButton></div>

                </Form>
              )}
            </Formik>

          </OffcanvasBody>
        </Offcanvas>

      </React.Fragment>
    )
  }
}
CustomeTemplates.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  match: PropTypes.object,
  onGetUserDetail: PropTypes.func,
  userdetail: PropTypes.object,
 
}
const mapStateToProps = ({ Login }) => (
  {
    userdetail: Login.userdetail
  })
const mapDispatchToProps = dispatch => ({
  onGetUserDetail: (agentId) => dispatch(getUserDetail(agentId)),
 
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CustomeTemplates))
